import { createContext } from 'react';
import type { IdentityPermission } from '@/iam/models';

export interface AuditEvent {
  id: string;
  type:
    | 'USER_CREATED'
    | 'USER_UPDATED'
    | 'ROLE_ASSIGNED'
    | 'INVITATION_SENT'
    | 'ACCOUNT_LOCKED'
    | 'ACCOUNT_ACTIVATED'
    | 'GROUP_CREATED'
    | 'GROUP_UPDATED'
    | 'GROUP_MEMBERS_ADDED'
    | 'GROUP_MEMBERS_REMOVED'
    | 'GROUP_ROLES_ASSIGNED'
    | 'GROUP_PRODUCTS_ASSIGNED'
    | 'GROUP_DELETED'
    | 'ROLE_CREATED'
    | 'ROLE_UPDATED'
    | 'ROLE_DELETED'
    | 'PERMISSION_UPDATED'
    | 'PERMISSION_REVOKED';
  targetId: string;
  occurredAt: string;
  metadata?: Record<string, string | number | boolean | null>;
}

export interface IdentityContextValue {
  permissions: Set<IdentityPermission>;
  hasPermission: (permission: IdentityPermission) => boolean;
  emitAuditEvent: (event: Omit<AuditEvent, 'id' | 'occurredAt'>) => void;
  recentAuditEvents: AuditEvent[];
}

export const IdentityContext = createContext<IdentityContextValue | undefined>(
  undefined,
);
